module.exports = __webpack_public_path__ + "static/media/BeVietnamPro-Bold.9e7a9f03.ttf";